/** Имена коллекций PocketBase (должны совпадать с админкой PB). */
export const COL_ROLES = 'roles'
export const COL_EMPLOYEES = 'employees'
/** Категории расходников (комплектация / справочник материалов). */
export const COL_CONSUMABLE_CATEGORIES = 'consumable_categories'
/** Категории готовой продукции. */
export const COL_PRODUCT_CATEGORIES = 'product_categories'
export const COL_CONSUMABLES = 'consumables'
export const COL_PRODUCTS = 'products'
export const COL_PRODUCT_COMPONENTS = 'product_components'
/** Заявки на производство и позиции (локальная база СУП). */
export const COL_PRODUCTION_REQUESTS = 'production_requests'
export const COL_PRODUCTION_REQUEST_LINES = 'production_request_lines'
/** Парк производственных станков. */
export const COL_MACHINES = 'machines'
/** Смены производства (настраиваемые в админке). */
export const COL_SHIFTS = 'shifts'
/** Справочник производственных сотрудников (без входа в систему). */
export const COL_PRODUCTION_WORKERS = 'production_workers'
/** Совместимость продукция ↔ станок. */
export const COL_PRODUCT_MACHINES = 'product_machines'
/** Слоты графика производства (Gantt). */
export const COL_SCHEDULE_SLOTS = 'schedule_slots'
/** Табель производственных сотрудников. */
export const COL_TIMESHEET_ENTRIES = 'timesheet_entries'
/** Производственный календарь: рабочие и нерабочие дни. */
export const COL_PRODUCTION_CALENDAR_DAYS = 'production_calendar_days'
/** Простои и события станков. */
export const COL_MACHINE_EVENTS = 'machine_events'
/** Движения по складу сырья. */
export const COL_INVENTORY_MOVEMENTS = 'inventory_movements'
/** Партии готовой продукции на складе ГП. */
export const COL_FINISHED_GOODS_LOTS = 'finished_goods_lots'
/** Отгрузки готовой продукции. */
export const COL_SHIPMENTS = 'shipments'
/** Строки отгрузки. */
export const COL_SHIPMENT_LINES = 'shipment_lines'
/** In-app уведомления. */
export const COL_NOTIFICATIONS = 'notifications'
/** Партии сырья (бобины и т.д.) для прослеживаемости. */
export const COL_MATERIAL_LOTS = 'material_lots'
/** Расход партий сырья по слотам графика. */
export const COL_SLOT_MATERIAL_USAGE = 'slot_material_usage'
